export class WebGLContextLostError extends Error {
  constructor(message?: string, options?: ErrorOptions) {
    super(message, options)
    this.name = "WebGLContextLostError"
  }
}
